module.exports = __webpack_public_path__ + "static/media/due-port13.3d171968.jpg";